import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { SplatControlConfigModelIconSizeEnum } from '../splat-control-config.model';
import { SplatModel } from './lib/splat-model.model';
import { SplatControlComponent } from './splat-control.component';

@Component({
    selector: '',
    template: `
        <ion-segment [(ngModel)]="view">
            <ion-segment-button value="icons">
                Splat
            </ion-segment-button>
            <ion-segment-button value="images">
                Backgrounds
            </ion-segment-button>
        </ion-segment>
        <ion-list [hidden]="view !== 'icons'" (ionChange)="changeIcon($event)" radio-group [(ngModel)]="icon">
            <ion-item>
                <small>Accident Damage</small>
            </ion-item>
            <ion-item *ngIf="iconSize === 1">
                <ion-label>Primary</ion-label>
                <ion-radio value="cross-red"></ion-radio>
            </ion-item>
            <ion-item *ngIf="iconSize === 0">
                <ion-label>Primary</ion-label>
                <ion-radio value="cross-red-small"></ion-radio>
            </ion-item>
            <ion-item *ngIf="iconSize === 1">
                <ion-label>Secondary</ion-label>
                <ion-radio value="circle-red"></ion-radio>
            </ion-item>
            <ion-item *ngIf="iconSize === 0">
                <ion-label>Secondary</ion-label>
                <ion-radio value="circle-red-small"></ion-radio>
            </ion-item>
            <ion-item *ngIf="iconSize === 1">
                <ion-label>Direction</ion-label>
                <ion-radio value="arrow-red"></ion-radio>
            </ion-item>
            <ion-item *ngIf="iconSize === 0">
                <ion-label>Direction</ion-label>
                <ion-radio value="arrow-red-small"></ion-radio>
            </ion-item>
            <ion-item>
                <small>Pre Accident Damage</small>
            </ion-item>
            <ion-item *ngIf="iconSize === 1">
                <ion-label>Damage</ion-label>
                <ion-radio value="circle-blue"></ion-radio>
            </ion-item>
            <ion-item *ngIf="iconSize === 0">
                <ion-label>Damage</ion-label>
                <ion-radio value="circle-blue-small"></ion-radio>
            </ion-item>
            <ion-item *ngIf="iconSize === 1">
                <ion-label>Direction</ion-label>
                <ion-radio value="arrow-blue"></ion-radio>
            </ion-item>
            <ion-item *ngIf="iconSize === 0">
                <ion-label>Direction</ion-label>
                <ion-radio value="arrow-blue-small"></ion-radio>
            </ion-item>
        </ion-list>
        <ion-list [hidden]="view != 'images'" (ionChange)="changeImage($event)" radio-group [(ngModel)]="image">
            <ion-item>
                <ion-label>Artic</ion-label>
                <ion-radio value="artic"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Bike</ion-label>
                <ion-radio value="bike"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Cab</ion-label>
                <ion-radio value="cab"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Car</ion-label>
                <ion-radio value="car"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Car Exploded</ion-label>
                <ion-radio value="car-exploded"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Car Reversed</ion-label>
                <ion-radio value="car-reversed"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Quad</ion-label>
                <ion-radio value="quad"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Tractor</ion-label>
                <ion-radio value="tractor"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Trailer</ion-label>
                <ion-radio value="trailer"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Truck</ion-label>
                <ion-radio value="truck"></ion-radio>
            </ion-item>
            <ion-item>
                <ion-label>Van</ion-label>
                <ion-radio value="van"></ion-radio>
            </ion-item>
        </ion-list>
    `
})
export class SplatToolsComponent {

    view: string = 'icons';
    image: string = 'car';
    icon: string = 'cross-red';
    protected loaded: boolean = false;
    iconSize: SplatControlConfigModelIconSizeEnum =
        SplatControlConfigModelIconSizeEnum.LARGE;

    splatComponent: SplatControlComponent;
    splatModel: SplatModel;

    constructor(protected viewCtrl: ViewController, protected navParams: NavParams) {

        this.splatModel = this.navParams.data.splatModel;
        this.splatComponent = this.navParams.data.splatComponent;
        this.iconSize = this.navParams.data.iconSize;

        this.icon = this.iconSize === SplatControlConfigModelIconSizeEnum.LARGE
            ? 'cross-red'
            : 'cross-red-small';

        this.splatComponent.setIcon(this.icon);
        this.image = this.splatComponent.getImage();
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.loaded = true;
        }, 500);
    }

    changeIcon(icon): void {
        this.icon = icon;
        this.splatComponent.setIcon(icon);
        if (!this.loaded) return;
        this.close();
    }

    changeImage(image): void {
        this.image = image;
        this.splatComponent.setImage(image);
    }

    close(): void {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/splat/form/splat-control-tools.component.ts